export default __webpack_public_path__ + "static/media/orgchart-vertical.93af0b58.png";